import { Component, ChangeDetectionStrategy, Input, inject } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { MessageContentUnion } from '@airgram/core/types/outputs';
import { MessageVideoNote } from '@airgram/core/types/outputs/MessageContent';
import { FilePart } from '@airgram/web';
import { FileReaderService } from '@src/core/services';
import { MultimediaSource } from '@src/models';
import { BaseResizableComponent } from '@src/app/modules/base';

@Component({
  selector: 'app-message-video-note',
  templateUrl: './message-video-note.component.html',
  styleUrls: ['../styles/message-content.scss', './message-video-note.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MessageVideoNoteComponent extends BaseResizableComponent {
  private readonly fileReaderService = inject(FileReaderService);

  @Input() set message(mess: MessageContentUnion | undefined) {
    this.messageVideoNote = mess as MessageVideoNote;
  }

  messageVideoNote?: MessageVideoNote;
  messageVideoNoteSource?: MultimediaSource;

  override ngOnInit(): void {
    super.ngOnInit();

    this.initVideoRecord();
  }

  private initVideoRecord(): void {
    if (!this.messageVideoNote) return;

    this.fileReaderService
      .getFilePart(this.messageVideoNote?.videoNote?.video)
      .pipe(takeUntil(this.destroyed$$))
      .subscribe(filePart => this.setVideoSource(filePart));
  }

  private setVideoSource(filePart?: FilePart): void {
    this.messageVideoNoteSource = { src: this.fileReaderService.getFileSource(filePart) };
    this.cdr.markForCheck();
  }
}
